const escape2Html = str => {
  var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
    return arrEntities[t];
  });
};

export { escape2Html };



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/util.js